/**
 * Homepage view configuration
 */

module.config(['$stateProvider', function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('homepage', {
            url: '/',
            controller: ['$scope', '$rootScope', 'drupal', '$state', 'headermanager', 'tools', '$cookies', function ($scope, $rootScope, drupal, $state, $headermanager, tools, $cookies) {
                $scope.loading = true;

                drupal.getPage('homepage').then(function (page) {
                    if (!page) {
                        // page not found
                        $state.go('404');
                    } else {
                        if ((navigator.language === 'it' || navigator.language === 'it-CH' || navigator.language === "it-IT") && $cookies.get('disableItalianPopin') !== 'ok'){
                            drupal.getItalianPopinTranslation().then(function(data) {
                                var translations = [];
                                data.forEach(function (dataTranslation) {
                                    translations[dataTranslation['translationName']] = dataTranslation;
                                });
                                swal({
                                    // title: '',
                                    text: translations['italian_popin_text_information']['value'],
                                    icon: "info",
                                    className: "italian-popin",
                                    buttons: {
                                        cancel: {
                                            text: translations['italian_popin_button_label_continue']['value'],
                                            value: false,
                                            visible: true,
                                            className: 'aqua-internships--button',
                                            closeModal: true
                                        },
                                        disable: {
                                            text: translations['italian_popin_checkbox_label_disable']['value'],
                                            value: "disable_italian_popin",
                                            visible: true,
                                            className: 'aqua-internships--button',
                                            closeModal: true
                                        },
                                        confirm: {
                                            text: translations['italian_popin_button_label_redirect']['value'],
                                            value: true,
                                            visible: true,
                                            className: 'aqua-internships--button',
                                            closeModal: true
                                        }
                                    }
                                }).then(function (goToItalian) {
                                    if (goToItalian === true) {
                                        window.open(translations['italian_popin_url_redirect']['value']);
                                    } else if (goToItalian === 'disable_italian_popin'){
                                        $cookies.put('disableItalianPopin', 'ok');
                                    }
                                });
                            });
                        }
                        // page found
                        $scope.page = page;

                        if (page.field_mots_cles_seo) {
                            tools.setMetaValue('keywords', page.field_mots_cles_seo);
                        }
                        if (page.field_description_seo) {
                            tools.setMetaValue('description', page.field_description_seo);
                        }

                        var carrousel = [];
                        carrousel = page.field_carousel.map(function (element) {
                            if (element.type === 'element_image') {
                                return { type: 'image', src: element.field_image.src, styles: element.field_image.styles };
                            } else if (element.type === 'element_video') {
                                return { type: 'video', src: element.field_link_video };
                            } else {
                                return {};
                            }
                        }).filter(function (element) {
                            return element.src;
                        });
                        // add custom theme
                        $headermanager.customize({
                            socials: true,
                            filled: false,
                            picture: carrousel

                            /* picture: page.field_image ? {type: 'image', src: page.field_image.src} : null */
                        });

                        // prepare widgets
                        $scope.widgets = page.field_widgets;

                        // change background if needed
                        if (page.field_theme_w_page && page.field_theme_w_page.color_background) {
                            $rootScope.pageBackground = page.field_theme_w_page.color_background;
                        }

                        // end loading
                        $scope.loading = false;
                    }
                });

                $scope.$on('$destroy', function () {
                    $rootScope.pageBackground = null;
                });
            }],
            templateUrl: 'src/views/section/section.html'
        });
}]);
